<template>
  <div class="modal modal-container" @click="closeModal">
    <div class="body">
      <span class="af af-close close right" @click="closeModal"></span>
      <slot />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Modal',
  emits: ['close'],
  setup(props, { emit }) {
    const closeModal = ({ target }: { target: HTMLElement }) => {
      if (
        target.className.includes('modal modal-container') ||
        target.className.includes('af af-close')
      ) {
        emit('close');
      }
    };

    return {
      closeModal,
    };
  },
});
</script>

<style lang="scss">
.modal {
  .body {
    .close {
      &.right {
        top: 0 !important;
        right: 0 !important;
        font-size: var(--font-size-12);
      }
    }
  }
}
</style>
